import React from 'react'

function Ewishlist() {
  return (
   <div>	<main className="page-content page-content-ones">
    <div className="tm-section tm-my-account-area bg-white tm-padding-section wishlist-section-ones">
      <div className="container">
        <div className="tm-myaccount">
          <div className="tab-content" id="account-ontent">
            <div className="tab-pane fade show active" id="account-dashboard" role="tabpanel" aria-labelledby="account-dashboard-tab">
              <div className="tm-myaccount-dashboard1">
                <div className="cart-box-two">
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <div className="mpt-cart mpt-wishlist text-center">
                        <img src="assets/images/empty-wishlist-photo.png" />
                        <h2 className="m-0">My Wishlist is Empty!</h2>
                        <p className="m-0">Tab heart button to start saving your favorite items.</p>
                        <a className="btn continue-shopping-btn mt-4" href="wishlist.html">Explore</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div></div></div></div></div></div></main></div>

  )
}

export default Ewishlist